import { queryOptions } from "@tanstack/react-query";

import * as subscriptionApi from "./api";

export const subscriptionQueryKeys = {
  plans: ["subscription", "plans"] as const,
  overview: (userId: string) => ["subscription", "overview", userId] as const,
  orders: (userId: string, page: number) => ["subscription", "orders", userId, page] as const,
} as const;

export function getSubscriptionPlansQueryOptions() {
  return queryOptions({
    queryKey: subscriptionQueryKeys.plans,
    queryFn: () => subscriptionApi.getSubscriptionPlans(),
  });
}

export function getSubscriptionOrdersQueryOptions(userId: string, page: number) {
  return queryOptions({
    queryKey: subscriptionQueryKeys.orders(userId, page),
    queryFn: () => subscriptionApi.getSubscriptionOrders(page),
  });
}

export function getSubscriptionOverviewQueryOptions(userId: string) {
  return queryOptions({
    queryKey: subscriptionQueryKeys.overview(userId),
    queryFn: () => subscriptionApi.getSubscriptionOverview(),
  });
}
